import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Component from '../components/Segments/index'
import { setSegment, fetchSegments } from '../ducks/segments'

function mapStateToProps(state) {
  return {
    segments: state.segments.list,
    fetched: state.segments.fetched,
    fetching: state.segments.fetching,
    auth: state.auth,
    segment: state.segments.selected,
    type: state.types.selected,
    project: state.projects.selected,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setSegment,
    fetchSegments,
    push,
  }

  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Segments.js